export const EXIT_DATA_SAVE_TIPS = '入力中のデータが\n保存されない可能性があります。'



